let API_HEADER = '';
let API_HEADERIMG = '';
let API_LOG = ''
import Environment from '../api/Environment';
const istest = process.env.NODE_ENV === 'test'

if (process.env.NODE_ENV === 'production') {
    API_LOG = 'http://sso.xyabcd.com/ssoauth'
    API_HEADER =  Environment.API_HEADER + '/userauth/gthmmc/index.php?m=gthmmc&c=index&a=';
} else if(istest){
    API_LOG = 'http://test.ssoauth.com/ssoauth'
    API_HEADER =  Environment.API_HEADER + '/userauth/gthmmc/index.php?m=gthmmc&c=index&a=';
}else{
    API_LOG = 'http://test.ssoauth.com/ssoauth'
    API_HEADER =  Environment.API_HEADER + '/userauth/gthmmc/index.php?m=gthmmc&c=index&a=';
}

export default {
    logIn: API_LOG + '/oauth/authorize?', //登录
    logOut: API_LOG + '/j_spring_security_logout?redirect_uri=', //登出
    host: API_HEADER,
    getUserInfo: API_HEADER + 'oauthGetUser',
    getDestination: API_HEADER + 'getdestinationlist', //查询旅游目的地tree列表
    Register: API_HEADER + 'loadRegister', //注册
    addDestination: API_HEADER + 'addDestination', //新增目的地
    modifyDestination: API_HEADER + 'modifyDestination', //修改目的地
    deleteDestination: API_HEADER + 'deleteDestination', //删除目的地
    getSystem: API_HEADER + 'getSystem',//查询系统
    addSystem: API_HEADER + 'addSystem', //新增系统
    modifySystem: API_HEADER + 'modifySystem', //修改系统
    deleteSystem: API_HEADER + 'deleteSystem', //删除系统
    getRight: API_HEADER + 'getRight',  //查询权限
    addRight: API_HEADER + 'addRight', //新增权限
    modifyRight: API_HEADER + 'modifyRight', //修改权限
    deleteRight: API_HEADER + 'deleteRight', //删除权限
    getAdministrators: API_HEADER + 'getAdministrators', //查询管理员
    addAdministrators: API_HEADER + 'addAdministrators', //新增管理员
    modifyAdministrators: API_HEADER + 'modifyAdministrators', //修改管理员
    deleteAdministrators: API_HEADER + 'deleteAdministrators', //删除管理员
    getNormalAccount:API_HEADER + 'getNormalAccount', //查询普通用户
    addNormalAccount:API_HEADER + 'addNormalAccount',//新增普通用户
    modifyNormalAccount:API_HEADER + 'modifyNormalAccount',//修改普通用户
    deleteNormalAccount:API_HEADER + 'deleteNormalAccount',//删除普通用户
    getBranch:API_HEADER + 'getBranch',//查询部门
    addBranch:API_HEADER + 'addBranch',//新增部门
    modifyBranch:API_HEADER + 'modifyBranch',//修改部门
    deleteBranch:API_HEADER + 'deleteBranch',//删除部门
    getRole:API_HEADER + 'getRole',//查询角色
    addRole:API_HEADER + 'addRole',//新增角色
    modifyRole:API_HEADER + 'modifyRole',//修改角色
    deleteRole:API_HEADER + 'deleteRole',//删除角色
    getOutLink:API_HEADER + 'getOutLink',//查询系统
    addOutLink:API_HEADER + 'addOutLink',//新增系统
    modifyOutLink:API_HEADER + 'modifyOutLink',//修改系统
    modifyAccountInformation:API_HEADER + 'getBlockchainorder', //修改当前登陆账户信息
    imageUpload: API_HEADERIMG + '/gthmmc/index.php?m=gthmmc&c=uploadWeb&a=imageUpload', //图片上传
};
